import EditDistributor from "@/pages/Distributors/Edit";

export default function AddDistributor() {
  return <EditDistributor mode="add" />;
}

